import { UserActionTypes } from "./user.type";

export const SetAuthedUser = () => ({
  type: UserActionTypes.AUTH_USER,
});

export const EndUserAccess = () => ({
  type: UserActionTypes.DESTORY_SESSION,
});
